import Loadable from 'components/Loadable';
import LoginLayout from '../layouts/LoginLayout';
import RouteErrorScreen from 'components/AppError/RouteErrorScreen';

 
const LoginPage     = Loadable(() => import('pages/auth/LoginPage'));
const RegisterPage  = Loadable(()=>import('pages/auth/RegisterPage'));
const RecoveryPage  = Loadable(()=>import('pages/auth/RecoveryPage'));


const LoginRoutes = {
    element: <LoginLayout/>,
    errorElement: <RouteErrorScreen />,
    children: [
        {
            path: '/login',
            element: <LoginPage/>
        },
        {
            path: '/register',
            element: <RegisterPage/>
        },
        {
            path: '/recovery',
            element: <RecoveryPage/>
        }
    ]
}

export default LoginRoutes;